import React from 'react';
import PropTypes from 'prop-types';
import GenericInput from '../common/GenericSearchBar/GenericInput';

class UserEmailInput extends React.Component {
  handleChange = (email) => {
    this.props.handleInputChange({ userEmail: email });
  };

  render() {
    return (
      <GenericInput
        handleInputChange={this.handleChange}
        inputName={'emailSearch'}
        inputPlaceholder={'Email del cliente'}
        value={this.props.values?.userEmail || ''}
      />
    );
  }
}

UserEmailInput.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  values: PropTypes.object
};

export default UserEmailInput;
